import albertJrImage from "@/assets/team/albert-saunders.jpeg";
import ucheImage from "@/assets/team/uche-obi.jpeg";
import nickImage from "@/assets/team/nick-eaton.jpeg";
import aaronImage from "@/assets/team/aaron-herring.jpeg";
import kenonImage from "@/assets/team/kenon-lattimore.jpeg";
import steveImage from "@/assets/team/steve-griffin.png";
import albertSrImage from "@/assets/team/albert-saunders-sr.png";
import antwonImage from "@/assets/team/antwon-salisbury.jpeg";
import zaronImage from "@/assets/team/zaron-johnson.jpeg";
import albertJrCard from "@/assets/team-cards/albert-oneil-saunders-jr-card.png.asset.json";
import ucheCard from "@/assets/team-cards/uche-obi-card.png.asset.json";
import albertSrCard from "@/assets/team-cards/albert-saunders-sr-card.png.asset.json";
import kenonCard from "@/assets/team-cards/kenon-lattimore-card.png.asset.json";
import steveCard from "@/assets/team-cards/steve-griffin-card.png.asset.json";
import aaronCard from "@/assets/team-cards/aaron-herring-card.png.asset.json";
import antwonCard from "@/assets/team-cards/antwon-salisbury-card.png.asset.json";
import zaronCard from "@/assets/team-cards/zaron-johnson-card.png.asset.json";
import nickCard from "@/assets/team-cards/nick-eaton-card.png.asset.json";
import shaunCard from "@/assets/team-cards/shaun-booysen-card.png.asset.json";
import brannakinCard from "@/assets/team-cards/brannakin-jacobs-card.png.asset.json";
import brianCard from "@/assets/team-cards/brian-acker-card.png.asset.json";

export type TeamCategory =
  | "Executive Leadership"
  | "Sales & Business Transformation Leadership"
  | "Technology & Robotics Team";

export interface TeamMember {
  slug: string;
  name: string;
  title: string;
  subtitle: string;
  image: string;
  cardImage: string;
  shortBio: string;
  fullBio: string;
  expertise: string[];
  industryExperience: string[];
  certifications: string[];
  areasServed: string[];
  linkedin: string;
  contactUrl: string;
  category: TeamCategory;
  featured: boolean;
}

export const TEAM_BOOKING_URL = "https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics";
export const TEAM_CALL_URL = "tel:+13369624539";
export const TEAM_CALL_DISPLAY = "(336) 962-4539";
export const COMPANY_LINKEDIN_URL = "https://www.linkedin.com/company/neil-ai-global-solutions";
export const ORGANIZATION_NAME = "Neil AI Global Solutions";
export const ORGANIZATION_URL = "https://neilaiglobalsolutionsllc.net";

export const teamMembers: TeamMember[] = [
  {
    slug: "albert-oneil-saunders-jr",
    name: "Albert O’Neil Saunders Jr.",
    title: "CEO & Founder",
    subtitle: "AI, Automation & Robotics Leadership",
    image: albertJrImage,
    cardImage: albertJrCard.url,
    shortBio:
      "Founder of Neil AI Global Solutions and visionary behind the company’s mission to help businesses leverage Artificial Intelligence, Automation, and Robotics to increase efficiency, improve customer experiences, and support employees.",
    fullBio:
      "Albert O’Neil Saunders Jr. is the founder and chief executive behind Neil AI Global Solutions. He leads the company’s vision, growth strategy, and market positioning across AI automation, robotics integration, workflow modernization, and client transformation. Albert works directly with business owners and leadership teams to turn complex automation opportunities into practical systems that improve operations, elevate customer experiences, and support employees instead of replacing them. His leadership continues to shape Neil AI as a trusted technology partner for organizations seeking future-ready operations.",
    expertise: [
      "AI automation strategy",
      "Robotics deployment planning",
      "Business transformation consulting",
      "Operational efficiency systems",
      "Customer experience modernization"
    ],
    industryExperience: [
      "Healthcare",
      "Hospitality",
      "Restaurants",
      "Commercial cleaning",
      "Warehousing",
      "Retail"
    ],
    certifications: [
      "AI automation strategy leadership",
      "Robotics deployment consulting",
      "Business workflow modernization"
    ],
    areasServed: ["Greensboro", "North Carolina", "Southeast United States", "Nationwide virtual consulting"],
    linkedin: "https://www.linkedin.com/in/albert-saunders-62a26137a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    contactUrl: TEAM_BOOKING_URL,
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "uche-obi",
    name: "Uche Obi",
    title: "Chief Operating Officer",
    subtitle: "Implementation, Deployment & Client Success",
    image: ucheImage,
    cardImage: ucheCard.url,
    shortBio:
      "Operations leader focused on implementation, deployment, client success, business transformation, and operational excellence.",
    fullBio:
      "Uche Obi oversees execution across client onboarding, internal delivery, implementation planning, and operational systems. He helps translate Neil AI’s automation and robotics solutions into repeatable deployment frameworks that drive measurable business outcomes. Uche is focused on operational excellence, ensuring that projects move smoothly from strategy to rollout, with the accountability, structure, and support needed for long-term success.",
    expertise: [
      "Operations leadership",
      "Implementation management",
      "Client onboarding",
      "Deployment coordination",
      "Business transformation"
    ],
    industryExperience: [
      "Commercial operations",
      "Financial services",
      "Automotive",
      "Logistics",
      "Enterprise service delivery"
    ],
    certifications: [
      "Operational process leadership",
      "Client success enablement",
      "Deployment and implementation strategy"
    ],
    areasServed: ["North Carolina", "Southeast United States", "Nationwide operations support"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: "https://api.leadconnectorhq.com/widget/bookings/uche-obi-personal-calendar-kvvpufn1m",
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "albert-saunders-sr",
    name: "Albert Saunders Sr.",
    title: "Chief Financial Officer",
    subtitle: "Financial Oversight, Growth Planning & Risk Management",
    image: albertSrImage,
    cardImage: albertSrCard.url,
    shortBio:
      "Financial strategist responsible for financial oversight, growth planning, risk management, and organizational sustainability.",
    fullBio:
      "Albert Saunders Sr. provides financial leadership for Neil AI Global Solutions, helping guide the company’s long-term planning, fiscal discipline, and responsible growth. He supports strategic decision-making around expansion, sustainability, and risk management, ensuring the company is positioned for durable success as demand for AI and robotics solutions continues to grow. His experience reinforces the company’s credibility with clients, partners, and stakeholders.",
    expertise: [
      "Financial oversight",
      "Growth planning",
      "Risk management",
      "Strategic budgeting",
      "Organizational sustainability"
    ],
    industryExperience: [
      "Executive finance",
      "Business leadership",
      "Organizational development",
      "Strategic planning"
    ],
    certifications: [
      "Executive financial leadership",
      "Strategic growth planning",
      "Risk and governance stewardship"
    ],
    areasServed: ["North Carolina", "Southeast United States"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "kenon-lattimore",
    name: "Kenon Lattimore",
    title: "Chief of Staff",
    subtitle: "Internal Operations, CRM Systems & Automation Deployment",
    image: kenonImage,
    cardImage: kenonCard.url,
    shortBio:
      "Leads internal operations, project execution, client onboarding, implementation support, CRM systems, and automation deployment.",
    fullBio:
      "Kenon Lattimore leads internal coordination across project execution, CRM workflow management, onboarding, and implementation support. He helps keep Neil AI’s delivery engine aligned, ensuring sales, operations, and client success teams stay connected through clear systems and consistent execution. Kenon plays a key role in helping new clients move from signed agreement to successful deployment with confidence.",
    expertise: [
      "Client onboarding",
      "CRM systems",
      "Project execution",
      "Implementation support",
      "Automation deployment"
    ],
    industryExperience: [
      "Operations support",
      "Client services",
      "Automation systems",
      "Internal process coordination"
    ],
    certifications: [
      "CRM workflow implementation",
      "Automation deployment support",
      "Project execution leadership"
    ],
    areasServed: ["North Carolina", "Southeast United States", "Remote CRM support nationwide"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: "https://api.leadconnectorhq.com/widget/bookings/kenon-lattimore-personal-calendar-xmfjnkrgr",
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "steve-griffin",
    name: "Steve Griffin",
    title: "VP of Sales & Head of Robotics",
    subtitle: "Enterprise Partnerships & Robotics Deployments",
    image: steveImage,
    cardImage: steveCard.url,
    shortBio:
      "Leads robotics growth initiatives, sales strategy, enterprise partnerships, and robotics deployments.",
    fullBio:
      "Steve Griffin leads Neil AI’s robotics growth strategy, managing enterprise sales conversations, solution alignment, and deployment readiness for organizations investing in automation. He works closely with business decision-makers to identify the right robotics fit, communicate ROI, and guide clients through discovery, planning, and rollout. Steve’s leadership helps bridge the gap between opportunity and execution for robotics buyers across multiple industries.",
    expertise: [
      "Robotics sales strategy",
      "Enterprise partnerships",
      "Deployment planning",
      "ROI-focused solution selling",
      "Commercial robotics consulting"
    ],
    industryExperience: [
      "Hospitality",
      "Healthcare",
      "Warehousing",
      "Restaurants",
      "Commercial cleaning"
    ],
    certifications: [
      "Robotics solutions advisory",
      "Commercial deployment leadership",
      "Enterprise sales strategy"
    ],
    areasServed: ["North Carolina", "Southeast United States", "Enterprise accounts nationwide"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Sales & Business Transformation Leadership",
    featured: true,
  },
  {
    slug: "aaron-herring",
    name: "Aaron Herring",
    title: "Sr Business Transformation Advisor",
    subtitle: "AI, Automation & Robotics Opportunity Mapping",
    image: aaronImage,
    cardImage: aaronCard.url,
    shortBio:
      "Works with organizations to identify opportunities for AI, automation, robotics, and operational improvement.",
    fullBio:
      "Aaron Herring helps organizations uncover practical ways to improve operations through AI automation and robotics. He works with leadership teams to assess current workflows, identify friction points, and recommend technology solutions that reduce repetitive effort, increase service consistency, and create room for growth. Aaron’s approach is grounded in real-world improvement, not hype.",
    expertise: [
      "Business transformation advisory",
      "Operational improvement",
      "AI opportunity assessment",
      "Robotics solution mapping",
      "Workflow modernization"
    ],
    industryExperience: [
      "Service businesses",
      "Hospitality",
      "Retail",
      "Logistics",
      "Healthcare operations"
    ],
    certifications: [
      "AI and robotics advisory support",
      "Business workflow improvement",
      "Operational efficiency planning"
    ],
    areasServed: ["North Carolina", "Triad region", "Remote discovery calls nationwide"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Sales & Business Transformation Leadership",
    featured: false,
  },
  {
    slug: "antwon-salisbury",
    name: "Antwon Salisbury",
    title: "Sr Business Transformation Advisor",
    subtitle: "Technology Solutions for Efficiency & Customer Experience",
    image: antwonImage,
    cardImage: antwonCard.url,
    shortBio:
      "Helps businesses implement practical technology solutions that improve efficiency and customer experiences.",
    fullBio:
      "Antwon Salisbury works with businesses that want to adopt smarter systems without adding unnecessary complexity. He helps clients evaluate operational challenges, prioritize practical solutions, and move toward AI and robotics deployments that improve both internal efficiency and the customer experience. His focus is on actionable transformation that delivers value quickly and sustainably.",
    expertise: [
      "Business transformation advisory",
      "Customer experience improvement",
      "Automation planning",
      "Technology solution alignment",
      "Efficiency consulting"
    ],
    industryExperience: [
      "Retail",
      "Hospitality",
      "Restaurants",
      "Commercial services",
      "Local business operations"
    ],
    certifications: [
      "AI and automation advisory",
      "Operational improvement consulting",
      "Client discovery and solution mapping"
    ],
    areasServed: ["North Carolina", "Southeast United States"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: "https://api.leadconnectorhq.com/widget/bookings/salisbury-antwon-business-calendar-neilai",
    category: "Sales & Business Transformation Leadership",
    featured: false,
  },
  {
    slug: "zaron-johnson",
    name: "Zaron Johnson",
    title: "Sr Business Transformation Advisor",
    subtitle: "AI & Robotics Solutions for Streamlined Operations",
    image: zaronImage,
    cardImage: zaronCard.url,
    shortBio:
      "Specializes in helping businesses streamline operations through AI and robotics solutions.",
    fullBio:
      "Zaron Johnson partners with organizations looking to modernize how work gets done. He helps identify where AI and robotics can create immediate operational gains, then guides clients toward solutions that support staff, improve workflow consistency, and position the business for scalable growth. Zaron is focused on helping companies move from manual strain to more intelligent systems.",
    expertise: [
      "Operations streamlining",
      "AI solution advisory",
      "Robotics opportunity planning",
      "Scalable workflow design",
      "Transformation consulting"
    ],
    industryExperience: [
      "Healthcare",
      "Warehousing",
      "Commercial cleaning",
      "Hospitality",
      "Facilities operations"
    ],
    certifications: [
      "AI and robotics strategy support",
      "Workflow optimization advisory",
      "Operational modernization consulting"
    ],
    areasServed: ["North Carolina", "Southeast United States", "Virtual consultations nationwide"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: "https://api.leadconnectorhq.com/widget/bookings/zaron-johnson-personal-calendar-vu7dtiom_",
    category: "Sales & Business Transformation Leadership",
    featured: false,
  },
  {
    slug: "nick-eaton",
    name: "Nick Eaton",
    title: "Technology Specialist",
    subtitle: "Certified PUDU Technician",
    image: nickImage,
    cardImage: nickCard.url,
    shortBio:
      "Certified robotics specialist responsible for deployment, mapping, training, maintenance, and technical support.",
    fullBio:
      "Nick Eaton is a certified robotics specialist focused on the technical side of successful deployment. He supports mapping, onboarding, training, maintenance, troubleshooting, and hands-on client support for robotics rollouts. Nick helps ensure that Neil AI’s robotics solutions perform reliably in live environments and that client teams feel confident using the technology day to day.",
    expertise: [
      "Robot deployment",
      "Facility mapping",
      "Client training",
      "Maintenance and support",
      "Technical troubleshooting"
    ],
    industryExperience: [
      "Commercial cleaning robots",
      "Delivery robots",
      "Hospitality robotics",
      "Healthcare support robotics",
      "On-site technology training"
    ],
    certifications: [
      "Certified PUDU Technician",
      "Robotics mapping and deployment",
      "Technical support and maintenance"
    ],
    areasServed: ["North Carolina", "On-site deployment across the Southeast", "Regional maintenance support"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: "https://api.leadconnectorhq.com/widget/bookings/nick-eaton-personal-calendar-ehsslmzzo",
    category: "Technology & Robotics Team",
    featured: true,
  },
  {
    slug: "shaun-booysen",
    name: "Shaun Booysen",
    title: "Director of Operations",
    subtitle: "Senior Business Transformation Advisor · Cape Town, South Africa",
    image: shaunCard.url,
    cardImage: shaunCard.url,
    shortBio:
      "Leads Neil AI Global Solutions’ operational growth and business-transformation initiatives across Cape Town, South Africa and the broader African market.",
    fullBio:
      "Shaun Booysen leads Neil AI Global Solutions’ operational growth and business-transformation initiatives in Cape Town, South Africa. He supports market development, client engagement, operational strategy, AI and robotics adoption, and the implementation of business-automation solutions across the African market.",
    expertise: [
      "South Africa market development",
      "African expansion strategy",
      "Operational leadership",
      "Business transformation",
      "AI adoption",
      "Commercial robotics",
      "Enterprise implementation",
      "Strategic partnerships",
      "Workforce modernization",
    ],
    industryExperience: [
      "Enterprise operations",
      "Commercial robotics",
      "Business transformation",
      "AI adoption programs",
    ],
    certifications: [
      "Business transformation advisory",
      "Operational leadership",
      "AI & robotics adoption strategy",
    ],
    areasServed: ["Cape Town", "South Africa", "African market"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "brannakin-jacobs",
    name: "Brannakin Jacobs",
    title: "Director of Technical Operations",
    subtitle: "Robotics Deployment & Field Implementation",
    image: brannakinCard.url,
    cardImage: brannakinCard.url,
    shortBio:
      "Leads technical operations, robotics deployment, implementation readiness, field operations, installation support, troubleshooting, and quality assurance.",
    fullBio:
      "Brannakin Jacobs leads technical operations for Neil AI Global Solutions, overseeing robotics deployment, implementation readiness, technical coordination, field operations, installation support, troubleshooting, and quality assurance for commercial robotics and AI-enabled solutions.",
    expertise: [
      "Technical operations",
      "Robotics deployments",
      "Installation coordination",
      "Field implementation",
      "Technical quality assurance",
      "Troubleshooting",
      "Deployment readiness",
      "Customer handoff",
      "Technical training",
      "Operational support",
    ],
    industryExperience: [
      "Commercial robotics",
      "Enterprise deployment",
      "On-site installation",
      "Field service operations",
    ],
    certifications: [
      "Certified PUDU deployment lead",
      "Robotics implementation",
      "Technical quality assurance",
    ],
    areasServed: ["North Carolina", "Southeast United States", "National deployment support"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Technology & Robotics Team",
    featured: true,
  },
  {
    slug: "brian-acker",
    name: "Brian D. Acker",
    title: "Director of AI Automation & Solutions Architecture",
    subtitle: "AI Employees · Voice AI · CRM & Workflow Automation",
    image: brianCard.url,
    cardImage: brianCard.url,
    shortBio:
      "Leads architecture and implementation of AI automation systems — AI employees, voice AI, CRM automation, workflow automation, and custom integrations.",
    fullBio:
      "Brian D. Acker leads the architecture and implementation of AI automation systems for Neil AI Global Solutions. He serves as a technical bridge between business strategy, sales, engineering, and client implementation, helping organizations deploy AI employees, voice AI, CRM automation, workflow automation, and custom integrations.",
    expertise: [
      "AI employee deployments",
      "Voice AI systems",
      "CRM automation",
      "Client workflow automation",
      "Custom integrations",
      "AI onboarding",
      "Enterprise implementation",
      "Solutions architecture",
      "Sales-to-engineering alignment",
      "Customer automation strategy",
    ],
    industryExperience: [
      "AI automation",
      "Enterprise CRM",
      "Voice AI",
      "Workflow modernization",
    ],
    certifications: [
      "AI solutions architecture",
      "CRM automation implementation",
      "Voice AI deployment",
    ],
    areasServed: ["Nationwide", "Enterprise clients", "Remote implementation"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Executive Leadership",
    featured: true,
  },
];

export const executiveLeadership = teamMembers.filter((member) => member.category === "Executive Leadership");
export const salesLeadership = teamMembers.filter((member) => member.category === "Sales & Business Transformation Leadership");
export const technologyTeam = teamMembers.filter((member) => member.category === "Technology & Robotics Team");

export const getTeamMemberBySlug = (slug?: string) =>
  teamMembers.find((member) => member.slug === slug);
